import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import themeDark from "../../components/shared/themeDark";
import theme from "../../components/shared/theme";
import AssignVehicleModal from "./AssignVehicleModal";
import { makeStyles, createStyles, Theme, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { MuiThemeProvider,ThemeProvider } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import ScheduleTransferModal from "./ScheduleTransferModal";
import TransferDetailsComponent from "../transferDetails/TransferDetailsComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { consts } from "../../common/consts";
import api from "../../store/api";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import LinearProgress from "@material-ui/core/LinearProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { format } from "date-fns";
import addDays from "date-fns/addDays";
import MapsWithMarker from "../shared/MapsWithMarker";
import PropTypes from "prop-types";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import { ActiveStepper } from "../../assets/iconComponents/Icons";
import eventNames from "../../store/signalr/eventNames";
import { addTaskForEvent, removeTaskForEvent } from "../../store/signalr/tasksForEvents";
import Grid from '@material-ui/core/Grid';
import { useForm, Controller } from "react-hook-form";
import Select from '@material-ui/core/Select';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { MenuItem } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { FormHelperText } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import ReasonForCancellationModal from "./ReasonForCancellationModel";

import  IndexedDb from "../patientCareRecord/IndexedDb";
interface IUserData {
  givenName: string;
  surName: string;
  email: string;
  role: string;
  IsAdmin: boolean;
  exp: number;
  location: string;
  ward: string;
  IsCustomer?: boolean | null | undefined,
  IsSMAUser?: boolean | null | undefined,
}

interface IAuthState {
  isAuthenticated?: boolean;
  token: string | null;
  userName: string | null;
  data: IUserData | null;
  sessionExpired: boolean;
  vehicleSessionId: string | null;
  vehicleNumber: string | null;
}

interface IState {
  TransferStatus: number;
  AssignedVehicle: string | null;
}

interface IVehicleLocation {
  latitude: number;
  linearDistance: number;
  longitude: number;
  objectNo: string;
  objectState: number;
  objectUid: string;
  routeDistance: number;
  routeTime: number;
  color: string;
}

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: "White",
    },
  },
  completed: {
    "& $line": {
      borderColor: "White",
    },
  },
  line: {
    borderColor: "Gray",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "red",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  circle: {
    width: 25,
    height: 25,
    borderRadius: "50%",
    backgroundColor: "White",
  },
  completed: {
    width: 25,
    height: 25,
    borderRadius: "50%",
    backgroundColor: "White",
  },
  active: {
    width: 35,
    height: 35,
  },
  inactive: {
    width: 25,
    height: 25,
    borderRadius: "50%",
    backgroundColor: "Transparent",
    border: "2px solid Gray",
  },
});

function QontoStepIcon(props: any) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;
  return (
    <div className={clsx(classes.root)}>
      {active ? <ActiveStepper className={classes.active} /> : null}
      {!active && !completed ? <div className={classes.inactive} /> : null}
      {completed ? <div className={classes.completed} /> : null}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

function getSteps() {
  return ["Picking up", "En route to dropoff", "Dropping off", "Complete"];
}

{
  /* Styles */
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(0),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    buttonRoot: {
      backgroundColor: "#F4B827",
      color: "#03090E",
      "&:hover": {
        backgroundColor: "#F4B827",
      },
      fontWeight: "bold",
    },
    container: {
      backgroundColor: "#00152e",
      backgroundSize: "100%",
      borderRadius: "0",
      width: "100%",
      padding: 60,
    },
    button: {
      width: "100%",
      marginRight: theme.spacing(1),
    },
    loading: {
      width: "100%",
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);

const useDialogStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(0),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        container: {
            backgroundColor: '#00152e',
            backgroundSize: '100%',
            borderRadius: '0',
            width: '100%',
            padding: 60,
        },
        button: {
            width: '100%',
        },
        dialogPaper: {
            minWidth: 500,
            margin: 0,
            borderRadius: 0,
            shadow: 'none',
            backgroundColor: '#fff',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 30,
        },
        modalTitle: {
            fontSize: 19,
            color: '#03090E',
        },
        helpText: {
            color: 'red',
            padding: theme.spacing(0, 0, 0, 2)
        },
        dropdownIcon: {
            top: 4
        }
    }),
);

interface IRoles {
  IsAdmin: boolean;
  SMADriver: boolean;
  CustomerDriver: boolean;
  IsNotSMAUser: boolean;
  IsCustomer:boolean;
  IsSMA:boolean;
}

const getRoles = (authStore: IAuthState): IRoles => {
  return {
    IsAdmin: authStore?.data?.IsAdmin || false,
    SMADriver: authStore?.data
      ? authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 && authStore?.vehicleNumber
        ? true
        : false
      : false,
    CustomerDriver: authStore?.data
      ? authStore?.data?.role?.indexOf(consts.Permissions.CustomerDriver) >= 0 && authStore?.vehicleNumber
        ? true
        : false
      : false,
    IsNotSMAUser: authStore.data?.location !== undefined && authStore.data?.location !== null && authStore.data?.location !== "",
    IsCustomer:authStore?.data?.IsCustomer ||false,
    IsSMA:authStore?.data?.IsSMAUser ||false
  };
};

const componentTaskId = "transferDetailsWidget";

{
  /* Body */
}
const TransferDetailsWidget = ({ transferData, getScheduleTransferDetails }: any) => {
  const [transferLoadingData, setTransferLoadingData] = React.useState<any>(transferData);
  const history = useHistory();
  const classes = useStyles();
  const classesDialog = useDialogStyles();
  const { authStore } = useSelector((state: RootState) => state);
  const [states, setStates] = useState<IState>({
    TransferStatus: transferLoadingData.status,
    AssignedVehicle: transferLoadingData.assignedVehicle,
  });
  const transferLoadingDataRef = React.useRef(transferLoadingData);
  const [loading, setLoading] = React.useState(false);
  const [roles, setRoles] = useState<IRoles>(getRoles(authStore));
  const [nearestVehicles, setNearestVehicles] = React.useState<IVehicleLocation[]>([]);
  const [center, setCenter] = useState({ lat: -33.85679100870898, lng: 151.21529457809382 });
  const [zoom, setZoom] = useState(13);
  const [activeStep, setActiveStep] = React.useState(1);
  const steps = getSteps();
  const [nurseAccess, setNurseAccess] = React.useState(false);
  const [pollingTrigger, setPollingTrigger] = useState<number>(0);
  const [mapFullScreen, setMapFullScreen] = React.useState(false);
  const [showScheduleModalAssignVehicleOption, setShowScheduleModalAssignVehicleOption] = React.useState(false);
  const { handleSubmit, watch, formState, getValues, setError, control, setValue, errors, trigger } = useForm();
  const[vechiclecount,setvechiclecount] =React.useState(0);
  React.useEffect(() => {
    transferLoadingDataRef.current = transferLoadingData;
  });

  const whenTransferUpdatedDo = (transferDetails: any) => {
    if (transferDetails.TransferId == transferLoadingDataRef.current.transferId) {
      getScheduleTransferDetails();
    }
  };

  const whenTransferScheduleUpdatedDo = (transferDetails: any) => {
    if (transferDetails.TransferId == transferLoadingDataRef.current.transferId) {
      getScheduleTransferDetails();
    }
  };
  const getVehicles = async (customer: any) => {
    let _loc=customer;
    const res = await api.getVechicles('customerId=' + _loc);
    if (res.hasError === false) {
        setvechiclecount(res._result.length);
    }
    }  
  useEffect(() => {
    setStates({
      TransferStatus: transferLoadingData.status,
      AssignedVehicle: transferLoadingData.assignedVehicle,
    });
    setRoles(getRoles(authStore));
    setStatus(transferLoadingData.status);
    //if (roles.IsNotSMAUser)
    consumeAPI();
  }, [transferLoadingData]);

  React.useEffect(() => {
    addTaskForEvent(eventNames.transferUpdated, componentTaskId, whenTransferUpdatedDo);
    addTaskForEvent(eventNames.transferScheduleUpdated, componentTaskId, whenTransferScheduleUpdatedDo);
    return () => {
      removeTaskForEvent(eventNames.transferUpdated, componentTaskId);
      removeTaskForEvent(eventNames.transferScheduleUpdated, componentTaskId);
    };
  }, [whenTransferUpdatedDo, whenTransferScheduleUpdatedDo]);

  useEffect(() => {
    setTransferLoadingData(transferData);
  }, [transferData]);

  useEffect(() => {
    consumeAPI();
  }, [pollingTrigger]);

  useEffect(() => {
    if (mapFullScreen === true) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
  }, [mapFullScreen]);

  useEffect(() => {
    //if (roles.IsNotSMAUser)
    startPolling();
    getVehicles(authStore.data?.CustomerId);
  }, []);

  const startPolling = () => {
    setInterval(() => {
      setPollingTrigger(Math.random() + Math.random());
    }, 20000);
  };

  const setStatus = (tripStatus: any) => {
    switch (tripStatus) {
      case 7:
        setActiveStep(0);
        break;
      case 8:
        setActiveStep(1);
        break;
      case 9:
        setActiveStep(2);
        break;
      case 4:
        setActiveStep(3);
        break;
      default:
        setActiveStep(5);
        break;
    }
  };

  const checkTransferState = async (transId: string): Promise<void> => {
    setLoading(true);
    try {
      const res = await api.getTransferState(`transferId=${transId}`);
      if (!res.data.errorRaised) {
        let updateData = {
          status: res.data.model.status,
          assignedVehicle: res.data.model.assignedVehicle,
          priority: res.data.model.priority,
          scheduledDate: res.data.model.scheduledDate,
        };
        setTransferLoadingData({ ...transferLoadingData, ...updateData });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const assignToMeClick = async (transferId: string): Promise<void> => {
    setLoading(true);
    try {
      const res = await api.assignJob("", { transferId: transferId });
      if (!res.data.hasError) {
        await checkTransferState(transferId);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const unassignCliсk = async (transferId: string): Promise<void> => {
    setLoading(true);
    try {
      const res = await api.unassignJob("", { transferId: transferId });
      if (!res.data.hasError) {
        await checkTransferState(transferId);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const startTripCall = async (transferId: any) => {
    setLoading(true);
    let ids: string[] = [transferId.toString()];
    await api
      .initTrip("", ids)
      .then(async (res) => {
        if (!res.errorRaised) history.push(`/transfertrip/${res.model.tripId}`);
        else if (res.errorRaised) {
          await checkTransferState(transferId);
          setLoading(false);
        }
      })
      .catch((error) => {
        handleClickOpen(error.response.data.errorMessage);
        setLoading(false);
      });
    setLoading(false);
  };

  const editBooking = (): void => {
    history.push(`/editbooking/${transferLoadingData.bookingId}/${transferLoadingData.transferId}`);
  };

  const trackVehicle = (): void => {
    if (transferLoadingData.assignedVehicle) history.push(`/trackvehicle/${transferLoadingData.assignedVehicle}`);
  };

  const cancelTransfer = async (transferId: any) => {
    let res = window.confirm("Do you want cancel this transfer?");

    if (res) {
      setLoading(true);
      await api
        .cancelTransfer(`transferId=${transferId}`, null)
        .then(async (result: any) => {
          if (!result.hasError) {
            await checkTransferState(transferId);
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };
  const submitpcr = async () =>{
    localStorage.setItem("PatientDB",format(new Date(),"dd-MM-yyyy HH:mm:ss"));
    try {
      const res = await api.getEditBookingPCR(`BookingId=${transferLoadingData.bookingId}&TransferId=${transferLoadingData.transferId}`).then((result: any) => {
        if (!result.data.errorRaised) {
          result = result.data.model;
          let  db = localStorage.getItem("PatientDB");
          localStorage.setItem("Patientidentification",JSON.stringify(result));
          localStorage.setItem("PCRCareGivers",JSON.stringify(result.pcrCareGivers));
           history.push("/patientCareRecord/edit/" + db);
        }
    }).catch((error) => {
        
    })
    } catch (err) {
      setLoading(false);
    }
    
  }
 
  const reasonForDelay = (id: any): any => {
    if (!id) return "";
    let idStr = id.toString();
    switch (idStr) {
      case "1":
        return "Patient has an appointment";
      case "2":
        return "Patient has an all-day appointment (needs morning transfer)";
      case "3":
        return "Patient being discharged and their bed is needed";
      case "4":
        return "Bed not available at destination until this time";
      default:
        return transferLoadingData.otherReasonDetails;
    }
  };

  const CreateLoadingLine = (props: any): JSX.Element => {
    const classes = useStyles();
    return (
      <div className={classes.loading} style={props.show ? { display: "" } : { visibility: "hidden" }}>
        <LinearProgress color="primary" />
      </div>
    );
  };

  const [AVdialogIsOpen, setAVDialogIsOpen] = React.useState(false);
  const AVopenDialog = () => setAVDialogIsOpen(true);
  const AVcloseDialog = async () => {
    await checkTransferState(transferLoadingData.transferId);
    setAVDialogIsOpen(false);
  };

  const [STdialogIsOpen, setSTDialogIsOpen] = React.useState(false);
  const STopenDialog = () => setSTDialogIsOpen(true);
  const STcloseDialog = async () => {
    setSTDialogIsOpen(false);
    await checkTransferState(transferLoadingData.transferId);
  };

  const [CNdialogIsOpen, setCNDialogIsOpen] = React.useState(false);
  const CNopenDialog = () => setCNDialogIsOpen(true);
  const CNcloseDialog = async () => {
    setCNDialogIsOpen(false);
    await checkTransferState(transferLoadingData.transferId);
  };

  const parseTime = (time: any): any | null => {
    if (time === null || time === "undefined") return "";
    if (typeof time === "string") return time;
    let d = new Date();
    if (time) {
      d.setHours(time.hours);
      d.setMinutes(time.minutes);
    } else return "";
    return `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
  };

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (message: string) => {
    setMessage(message);
    setOpen(true);
  };

  const ShowDialogMessage = () => {
    return (
      <div>
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">Not able to start</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const parseDay = (item: string) => {
    if (!item || item.indexOf("T") < 0) return "";
    item = item.split("T")[0];
    if (format(new Date(), "yyyy-MM-dd") == item) return "today";
    if (format(addDays(new Date(), 1), "yyyy-MM-dd") == item) return "tomorrow";
    return format(new Date(item), "EEEE").toLowerCase();
  };
  const getRequestedStatusString = (row: any) => {
    let onStr = "on ";
    const dayStr = parseDay(row?.bookingDate);
    if (dayStr == "today" || dayStr == "tomorrow") {
      onStr = "";
    }
    if (row?.status==13 || row?.isAdhocRequested==true){
      if (row?.pickupFrom && row?.pickupTo)
        return `Requested pickup after ${parseTime(row?.pickupFrom)} and before ${parseTime(row?.pickupTo)} ${onStr}${dayStr}`;
      else if (row?.pickupFrom) return `Requested pickup after ${parseTime(row?.pickupAfterTime)} ${dayStr}`;
      else if (row?.pickupTo) return `Requested pickup before ${parseTime(row?.pickupBeforeTime)} ${dayStr}`;
      else if (row?.dropOffFrom && row?.dropOffTo)
        return `Requested dropoff after ${parseTime(row?.dropOffFrom)} and before ${parseTime(row?.dropOffTo)} ${onStr}${dayStr}`;
      else if (row?.dropOffFrom) return `Requested dropoff after ${parseTime(row?.dropOffFrom)} ${dayStr}`;
      else if (row?.dropOffTo) return `Requested dropoff before ${parseTime(row?.dropOffTo)} ${dayStr}`;
      else {
        return "";
      }
    }
    // else if (row?.status == 2 || row?.status == 3 || row?.status == 4 || row?.status == 6 || row?.status == 7 || row?.status == 8 || row?.status == 9 || row?.status == 11 || row?.status == 12)
    //   return `Requested pickup at ${String(new Date(row.scheduledDate).getHours()).padStart(2, "0") + ":" + String(new Date(row.scheduledDate).getMinutes()).padStart(2, "0")} ${onStr} ${dayStr}`;
     else if (row?.anyTimeOfTheDay === true)
      return `Requested pickup any time ${onStr}${dayStr}`
    else if (row?.pickupAfterTime && row?.pickupBeforeTime)
      return `Requested pickup after ${parseTime(row?.pickupAfterTime)} and before ${parseTime(row?.pickupBeforeTime)} ${onStr}${dayStr}`;
    else if (row?.pickupAfterTime) return `Requested pickup after ${parseTime(row?.pickupAfterTime)} ${dayStr}`;
    else if (row?.pickupBeforeTime) return `Requested pickup before ${parseTime(row?.pickupBeforeTime)} ${dayStr}`;
    else if (row?.dropoffAfterTime && row?.dropoffBeforeTime)
      return `Requested dropoff after ${parseTime(row?.dropoffAfterTime)} and before ${parseTime(row?.dropoffBeforeTime)} ${onStr}${dayStr}`;
    else if (row?.dropoffAfterTime) return `Requested dropoff after ${parseTime(row?.dropoffAfterTime)} ${dayStr}`;
    else if (row?.dropoffBeforeTime) return `Requested dropoff before ${parseTime(row?.dropoffBeforeTime)} ${dayStr}`;
    else {
      return "";
    }
  };

  const consumeAPI = () => {
    if (!transferLoadingData.assignedVehicle) return;
    setLoading(true);
    api
      .VehicleTrackingForNurseStation("", {
        vehicle: transferLoadingData.assignedVehicle,
        addrno: "E4:04:39:56:F2:CF",
        latitude: 0,
        longitude: 0,
        priority: 1,
        maxdistance: 1000,
        timeZone: "Australia_NSW",
        transferId: transferLoadingData.transferId,
      })
      .then(
        (data: any) => {
          if (data.errorRaised || data.hasError) {
            //clearInterval();
            setNurseAccess(false);
            setLoading(false);
            return;
          }
          if (data.model.results.length <= 0) {
            //clearInterval();
            setNurseAccess(false);
            setLoading(false);
            return;
          }

          setNurseAccess(true);
          setNearestVehicles(data.model.results);
          const { latitude, longitude } = data.model.results[0];
          setCenter({ lat: latitude / 1000000, lng: longitude / 1000000 });
          setLoading(false);
        },
        (err) => {
          setNurseAccess(false);
          //clearInterval();
          setLoading(false);
        }
      );
  };

  return (
    <MuiThemeProvider theme={themeDark}>
      {mapFullScreen && (
        <div style={{ width: "100%", position: "absolute", top: 0, left: 0, zIndex: 9 }}>
          <MapsWithMarker
            nearestVehicles={nearestVehicles}
            center={center}
            zoom={zoom}
            height={"100vh"}
            isNurseView={true}
            onZoomButtonClick={() => setMapFullScreen((prev) => !prev)}
          />
        </div>
      )}
      <div
        style={
          roles.IsNotSMAUser
            ? { width: "100%", position: "absolute", left: 0, right: 0, paddingTop: 5 }
            : { width: "100%", position: "absolute", left: 0, right: 0, paddingTop: 5 }
        }
      >
        {loading ? <CreateLoadingLine show={loading} /> : null}
        {
          //roles.IsNotSMAUser && !roles.IsAdmin && nurseAccess && (transferLoadingData.status == 7 || transferLoadingData.status == 8 || transferLoadingData.status == 9 || transferLoadingData.status == 4) ?
          transferLoadingData.status == 7 || transferLoadingData.status == 8 || transferLoadingData.status == 9 || transferLoadingData.status == 4 ? (
            <div style={{ width: "100%", position: "absolute", left: 0, right: 0 }}>
              <MapsWithMarker
                nearestVehicles={nearestVehicles}
                center={center}
                zoom={zoom}
                height={"30vh"}
                isNurseView={true}
                onZoomButtonClick={() => setMapFullScreen((prev) => !prev)}
              />
              <Stepper style={{ marginTop: 30 }} alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
          ) : null
        }
      </div>

      <Paper
        className={classes.container}
        style={
          transferLoadingData.status == 7 || transferLoadingData.status == 8 || transferLoadingData.status == 9 || transferLoadingData.status == 4
            ? { marginTop: "45vh", backgroundColor: "#00152e" }
            : { marginTop: "0vh", backgroundColor: "#00152e" }
        }
      >
        {/*Button Pannel*/}
        {
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center" }}>
            <div style={{ justifyContent: "flex-end", textAlign: "right", alignItems: "end", paddingRight: 30, fontSize: 19 }}>
              {getRequestedStatusString(transferLoadingData) ? (
                <div style={{ textAlign: "right" }}>{getRequestedStatusString(transferLoadingData)}</div>
              ) : null}
              {/* {(transferLoadingData.reasonForThisTime && transferLoadingData.status!=11) ? (
                <div style={{ textAlign: "right" }}>Reason: {reasonForDelay(transferLoadingData.reasonForThisTime)}</div>
              ) : null} */}
            </div>
            {/* Vehicle Assigning Status */}
            {(roles.SMADriver || roles.CustomerDriver) &&
            states.TransferStatus === consts.TransferStatus.ScheduledForTransport &&
            authStore.vehicleNumber?.toString() === states.AssignedVehicle ? (
              <div style={{ marginRight: 30, color: "#FFF", fontSize: 19 }}>Assigned to me</div>
            ) : null}
            {states.TransferStatus === consts.TransferStatus.ScheduledForTransport &&
              states.AssignedVehicle &&
              authStore.vehicleNumber?.toString() !== states.AssignedVehicle ? (
              <div style={{ marginRight: 30, color: "#FFF", fontSize: 19 }}>Assigned to {transferLoadingData.assignedVehicle}</div>
            ) : null}

            {/* Vehicle Assigning Action */}
            {(roles.SMADriver || roles.CustomerDriver) &&
            states.TransferStatus === consts.TransferStatus.ScheduledForTransport &&
            authStore.vehicleNumber?.toString() === states.AssignedVehicle ? (
              <div
                onClick={() => unassignCliсk(transferLoadingData.transferId)}
                style={{ marginRight: 15, color: "#F4B827", fontSize: 19, cursor: "pointer" }}
              >
                Unassign
              </div>
            ) : null}
            {(roles.SMADriver || roles.CustomerDriver) &&
            states.TransferStatus === consts.TransferStatus.ScheduledForTransport &&
            (!states.AssignedVehicle || authStore.vehicleNumber?.toString() !== states.AssignedVehicle) ? (
              <div
                onClick={() => assignToMeClick(transferLoadingData.transferId)}
                style={{ marginRight: 15, color: "#F4B827", fontSize: 19, cursor: "pointer" }}
              >
                Assign To Me
              </div>
            ) : null}
            {roles.IsAdmin && states.TransferStatus === consts.TransferStatus.ScheduledForTransport ? (
              <Button className={classes.buttonRoot} onClick={AVopenDialog} style={{ marginRight: 15 }}>
                Assign To Vehicle
              </Button>
            ) : null}
            {roles.IsCustomer &&
            (authStore?.data?.role
              ?.split(",")
              ?.some((p) => p === consts.Permissions.Addtransfers|| p === consts.Permissions.AddtransfersSecondary )) 
            && vechiclecount > 0 && states.TransferStatus === consts.TransferStatus.ScheduledForTransport ? (
              <Button className={classes.buttonRoot} onClick={AVopenDialog} style={{ marginRight: 15 }}>
                Assign To Vehicle
              </Button>
            ) : null}
              {roles.IsSMA &&
               (authStore?.data?.role
                ?.split(",")
                ?.some((p) => p === consts.Permissions.SMAAddtransfers ||  p === consts.Permissions.SMAAddtransfersSecondary )) 
              && !roles.IsAdmin && states.TransferStatus === consts.TransferStatus.ScheduledForTransport ? (
              <Button className={classes.buttonRoot} onClick={AVopenDialog} style={{ marginRight: 15 }}>
                Assign To Vehicle
              </Button>
            ) : null}
            {/* Editing Action */}
           {roles.IsSMA ?
            ((authStore?.data?.role
              ?.split(",")
              ?.some((p) => p === consts.Permissions.SMAEditBooking)) &&
              (states.TransferStatus === consts.TransferStatus.Requested ||
                states.TransferStatus === consts.TransferStatus.AdhocRequest ||
                states.TransferStatus === consts.TransferStatus.ScheduledForTransport)) ? (
              <div
                onClick={CNopenDialog} //cancelTransfer(transferLoadingData.transferId)
                style={{
                  marginRight: "15px",
                  color: "#F4B827",
                  fontSize: "18px",
                  cursor: "pointer",
                  border: "2px solid rgb(244, 184, 39)",
                  padding: "4.75px 24px",
                  borderRadius: "5px",
                  fontFamily: "'Lato', sans-serif",
                  lineHeight: "1.75",
                  fontWeight: "bold",
                }}
              >
                Cancel Transfer
              </div>
            ) : null:
            
            (transferLoadingData.canBeCancelledByCurrentUser
               &&
              (states.TransferStatus === consts.TransferStatus.Requested ||
                states.TransferStatus === consts.TransferStatus.AdhocRequest ||
                states.TransferStatus === consts.TransferStatus.ScheduledForTransport)) ? (
              <div
                onClick={CNopenDialog} //cancelTransfer(transferLoadingData.transferId)
                style={{
                  marginRight: "15px",
                  color: "#F4B827",
                  fontSize: "18px",
                  cursor: "pointer",
                  border: "2px solid rgb(244, 184, 39)",
                  padding: "4.75px 24px",
                  borderRadius: "5px",
                  fontFamily: "'Lato', sans-serif",
                  lineHeight: "1.75",
                  fontWeight: "bold",
                }}
              >
                Cancel Transfer
              </div>
            ) : null
            
            }
             
            {transferLoadingData.canBeEditedByCurrentUser &&
              (states.TransferStatus === consts.TransferStatus.Requested ||
                states.TransferStatus === consts.TransferStatus.AdhocRequest ||
                states.TransferStatus === consts.TransferStatus.ScheduledForTransport) ? (
              <div
                onClick={editBooking}
                style={{
                  marginRight: "15px",
                  color: "#F4B827",
                  fontSize: "18px",
                  cursor: "pointer",
                  border: "2px solid rgb(244, 184, 39)",
                  padding: "4.75px 24px",
                  borderRadius: "5px",
                  fontFamily: "'Lato', sans-serif",
                  lineHeight: "1.75",
                  fontWeight: "bold",
                }}
              >
                Edit Booking
              </div>
            ) : null}

            {/* Scheduling Action */}
            {transferLoadingData.canBeScheduledByCurrentUser &&
              !transferLoadingData.existsPlannerForLocation &&
              states.TransferStatus === consts.TransferStatus.ScheduledForTransport ? (
              <div
                onClick={STopenDialog}
                style={{
                  marginRight: "15px",
                  color: "#F4B827",
                  fontSize: "18px",
                  cursor: "pointer",
                  border: "2px solid rgb(244, 184, 39)",
                  padding: "4.75px 24px",
                  borderRadius: "5px",
                  fontFamily: "'Lato', sans-serif",
                  lineHeight: "1.75",
                  fontWeight: "bold",
                }}
              >
                Change Time/Priority
              </div>
            ) : null}
            {/* {transferLoadingData.canBeScheduledByCurrentUser &&
            !transferLoadingData.existsPlannerForLocation &&
            states.TransferStatus !== consts.TransferStatus.Requested 
            ? (
              roles.IsNotSMAUser === false && roles.IsCustomer === false
              ?
              <Button className={classes.buttonRoot} onClick={STopenDialog}>
                Schedule
              </Button>
              :null
            ) : null} */}
            
            {transferLoadingData.canBeScheduledByCurrentUser && 
            states.TransferStatus === consts.TransferStatus.AdhocRequest ||
            states.TransferStatus === consts.TransferStatus.ScheduledForTransport? (
             roles.IsNotSMAUser === false && roles.IsCustomer === false
             ?
              <Button
                className={classes.buttonRoot}
                onClick={() => {
                  setSTDialogIsOpen(true);
                  setShowScheduleModalAssignVehicleOption(true);
                }}
              >
                Schedule
              </Button>
              :null
            ) : null}
            {(roles.SMADriver || roles.CustomerDriver) &&
            states.TransferStatus === consts.TransferStatus.ScheduledForTransport &&
            authStore.vehicleNumber?.toString() === states.AssignedVehicle ? (
              <Button className={classes.buttonRoot} onClick={() => startTripCall(transferLoadingData.transferId)} endIcon={<ArrowForwardIosIcon />}>
                Start Trip
              </Button>
            ) : null}

            {states.TransferStatus === consts.TransferStatus.InProgress ||
              states.TransferStatus === consts.TransferStatus.EnRouteToDestination ||
              states.TransferStatus === consts.TransferStatus.DroppingOff ||
              states.TransferStatus === consts.TransferStatus.PickingUp ? (
              <Button
                style={{ marginRight: 30, backgroundColor: "#203248", color: "white", fontSize: 19, cursor: "initial", fontWeight: "bold" }}
                disabled
              >
                {transferLoadingData.assignedVehicle} Picking Up
              </Button>
            ) : null}
            {!roles.IsNotSMAUser &&
              (states.TransferStatus === consts.TransferStatus.InProgress ||
                states.TransferStatus === consts.TransferStatus.EnRouteToDestination ||
                states.TransferStatus === consts.TransferStatus.DroppingOff ||
                states.TransferStatus === consts.TransferStatus.PickingUp) ? (
              <Button className={classes.buttonRoot} onClick={trackVehicle}>
                Track Vehicle
              </Button>
            ) : null}

            {states.TransferStatus === consts.TransferStatus.Aborted ? (
              <Button style={{ backgroundColor: "#203248", color: "white", fontSize: 19, cursor: "initial" }} disabled>
                Transfer Aborted
              </Button>
            ) : null}
            {states.TransferStatus === consts.TransferStatus.Cancelled ? (
              <Button style={{ backgroundColor: "#203248", color: "white", fontSize: 19, cursor: "initial" }} disabled>
                Transfer Cancelled
              </Button>
            ) : null}
            {states.TransferStatus === consts.TransferStatus.Complete ? (
              <Button style={{ backgroundColor: "#203248", color: "white", fontSize: 19, cursor: "initial" }} disabled>
                Transfer Complete
              </Button>
            ) : null}
            {authStore?.data?.role
                    ?.split(",")
                    ?.some((p) => p === consts.Permissions.SubmitPatientCareRecord
                    || p === consts.Permissions.SMASubmitPatientCareRecords)  
                          && (states.TransferStatus === consts.TransferStatus.InProgress ||
                              states.TransferStatus === consts.TransferStatus.EnRouteToDestination ||
                              states.TransferStatus === consts.TransferStatus.DroppingOff ||
                              states.TransferStatus === consts.TransferStatus.PickingUp) && (                   
              <Button
                className={classes.buttonRoot}
                onClick={() => submitpcr()}
                style={{ marginLeft: 15 }}
              >
                Record PCR
              </Button>
              )}
          </div>
        }
        {/* Page Body*/}
        {transferLoadingData ? <TransferDetailsComponent data={transferLoadingData} theme="dark" /> : null}
      </Paper>

      <AssignVehicleModal open={AVdialogIsOpen} onClose={AVcloseDialog} transferId={transferLoadingData.transferId} currentTripPlannerId={transferLoadingData.tripPlannerId} fromTransfer={true} smaUser={authStore.data?.IsSMAUser} />
      <ReasonForCancellationModal open={CNdialogIsOpen} setTransferLoadingData = {setTransferLoadingData} transferLoadingData ={transferLoadingData} onClose={CNcloseDialog} transferId={transferLoadingData.transferId} currentTripPlannerId={transferLoadingData.tripPlannerId} fromTransfer={true} smaUser={authStore.data?.IsSMAUser} />
      <ScheduleTransferModal
        open={STdialogIsOpen}
        onClose={() => {
          setShowScheduleModalAssignVehicleOption(false);
          STcloseDialog();
        }}
        transferId={transferLoadingData.transferId}
        currentPriority={transferLoadingData.priority}
        fromTransfer={true}
        locationId={transferLoadingData.destinationCustomerLocationId}
        scheduleDate={transferLoadingData.scheduledDate}
        currentTransferData={transferData}
        showScheduleModalAssignVehicleOption={showScheduleModalAssignVehicleOption}
        roles={roles}
      />

      <MuiThemeProvider theme={theme}>
        <ShowDialogMessage />
      </MuiThemeProvider>
    </MuiThemeProvider>
  );
};

export default TransferDetailsWidget;
